import { Layout } from 'components/layout';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';

import { IBlogPost } from 'constants/types';

import { Icon } from 'common/icon';
import { Breadcrumbs } from 'components/bredcrambs';
import { Title } from 'components/title';
import { Anchor } from 'constants/anchors';
import { Routes } from 'constants/routes';
import { blogAndNewsPage } from 'constants/routes-breadcrumbs';
import { INavItem } from 'constants/types';
import { NavigationBar } from '../casino/casino-navigations';
import { News } from '../home/news';
import styles from './styles.module.css';

export type Props = {
  blogs: IBlogPost[];
  news: IBlogPost[];
  rtpchecks: IBlogPost[];
  bigwins: IBlogPost[];
};

const navItems: INavItem[] = [
  {
    icon: <Icon.Options />,
    text: 'Blogs',
    anchor: Routes.blogAndNewsCategory('blogs'),
  },

  {
    icon: <Icon.Search width="16" height="16" />,
    text: 'RTP Checks',
    anchor: Routes.blogAndNewsCategory('rtpchecks'),
  },

  {
    icon: <Icon.Trophy />,
    text: 'Bigwins',
    anchor: Routes.blogAndNewsCategory('bigwins'),
  },

  {
    icon: <Icon.NewsSecond />,
    text: 'News',
    anchor: Routes.blogAndNewsCategory('news'),
  },
];

export const BlogAndNews = ({ blogs, news, rtpchecks, bigwins }: Props) => {
  let metadata = allMetadata.blogAndNews;
  let title = 'Essential Topics About Online Casinos';
  let description = `Dive into the world of online casinos with our comprehensive guides and in-depth articles. Whether you're looking to understand the basics, improve your gaming strategies, or find the best online casinos, we’ve gathered the best content to give you a complete and safe gambling experience. Stay informed with expert advice and up-to-date information for every level of player. Let us be your trusted source for everything related to online gaming.`;

  return (
    <div>
      <CustomMetadata metadata={metadata} />
      <Layout bgVariant="home" hasFooter isSearchInputMobileVisible>
        <main className={styles.main}>
          <div className={styles.container_s}>
            <div className={styles.breadcrumbs}>
              <Breadcrumbs items={[...blogAndNewsPage]} />
            </div>
            <Title
              text={title}
              description={description}
              variant="twocolumns"
              navigationBar={
                <div className={styles.navigation}>
                  <NavigationBar
                    arrow
                    items={navItems}
                    navItemClassName={styles.navItem}
                    variantPadding="small"
                    arrowOpacity="1"
                  />
                </div>
              }
            />
            <News
              data={blogs}
              title={'Blogs'}
              arrow
              variant={'exetended'}
              hasIcon
              count={blogs.length}
              anchor={Anchor.NewsBlogs}
              urlHeader={Routes.blogAndNewsCategory('blogs')}
            />
            <News
              data={news}
              title={'News'}
              arrow
              variant={'topLongMainNews'}
              hasIcon
              count={news.length}
              anchor={Anchor.News}
              urlHeader={Routes.blogAndNewsCategory('news')}
            />
            <News
              data={rtpchecks}
              title={'RTP Checks'}
              arrow
              variant={'reverseBase'}
              hasIcon
              count={rtpchecks.length}
              anchor={Anchor.NewsRTPChecks}
              urlHeader={Routes.blogAndNewsCategory('rtpchecks')}
            />
            <News
              data={bigwins}
              title={'Big Wins'}
              arrow
              variant={'bottomLongMainNews'}
              hasIcon
              count={bigwins.length}
              anchor={Anchor.NewsBigwins}
              urlHeader={Routes.blogAndNewsCategory('bigwins')}
            />
          </div>
        </main>
      </Layout>
    </div>
  );
};
